import { useEffect } from 'react';
import { updateAppVersion } from '../REST/version/updateVersion';
import { modalUpdate } from '../services/pwa/cycleToUpdate';

const useCleanSW = () => {
  useEffect(() => {
    updateAppVersion()
      .then(({ data }) => {
        if (!data.data) return;
        if (
          data?.data?.attributes?.needUpdate &&
          data?.data?.attributes?.lastVersion
        ) {
          return modalUpdate(data?.data?.attributes?.lastVersion);
        }
        console.log('App Version : ', data);
      })
      .catch(err => console.error(err));
  }, []);
};
export default useCleanSW;
